import { render, staticRenderFns } from "./InterSchemeDetail.vue?vue&type=template&id=211b5b88&"
import script from "./InterSchemeDetail.vue?vue&type=script&lang=js&"
export * from "./InterSchemeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports